import React from 'react';

import Icon from '../Icon/Icon';

const TickCircle = (props) => {
    return (
        <Icon width='24' height='24' {...props}>
            <g fill='none' fillRule='evenodd'>
                <circle fill='#00D1D2' cx='12' cy='12' r='12' />
                <path
                    stroke='#34303D'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m6 13.29 3.393 3.552L18 8'
                />
            </g>
        </Icon>
    );
};

export default TickCircle;
